import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BusinessRegistrationPageComponent } from './business-registration-page/business-registration-page.component'
import { BusinessIntroComponent } from './business-registration-page/business-intro/business-intro.component'
import { BusinessGoodPointComponent } from './business-registration-page/business-good-point/business-good-point.component'
import { BusinessServiceComponent } from './business-registration-page/business-service/business-service.component'
import { BusinessRegistrationRoutingModule } from './business-registration-routing.module'
import { CustomTranslateModule } from '@flowaccount/landing'
import { CoreModule } from '../../core.module'
import { BusinessBannerComponent } from './business-registration-page/business-banner/business-banner.component'
import { BusinessRegisterByEmailComponent } from './business-registration-page/business-register-by-email/business-register-by-email.component'
import { BusinessRegisterCompanyComponent } from './business-registration-page/business-register-company/business-register-company.component'
import { BusinessRegisterOnlineByYourselfComponent } from './business-registration-page/business-register-online-by-yourself/business-register-online-by-yourself.component'
import { BusinessRegistrationTestimonialComponent } from './business-registration-page/business-registration-testimonial/business-registration-testimonial.component'
import { SwiperConfigInterface, SWIPER_CONFIG } from 'ngx-swiper-wrapper'
import { BusinessRegistrationAdsComponent } from './business-registration-ads/business-registration-ads.component'
import { BusinessRegistrationAdsIntroComponent } from './business-registration-ads/business-registration-ads-intro/business-registration-ads-intro.component'
import { BusinessRegistrationAdsDetailListComponent } from './business-registration-ads/business-registration-ads-detail-list/business-registration-ads-detail-list.component'
import { BusinessRegistrationAdsStepsComponent } from './business-registration-ads/business-registration-ads-quickly-5-steps/business-registration-ads-steps.component'
import { BusinessRegistrationAdsVdoInviteComponent } from './business-registration-ads/business-registration-ads-vdo-invite/business-registration-ads-vdo-invite.component'
import { BusinessRegistrationAds9CompanyComponent } from './business-registration-ads/business-registration-ads-9-company/business-registration-ads-9-company.component'
import { BusinessRegistrationAdsKnowledgeComponent } from './business-registration-ads/business-registration-ads-knowledge/business-registration-ads-knowledge.component'

// swiper
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto',
  loop: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    hideOnClick: true,
  },
}
@NgModule({
  declarations: [
    BusinessRegistrationPageComponent,
    BusinessIntroComponent,
    BusinessGoodPointComponent,
    BusinessServiceComponent,
    BusinessBannerComponent,
    BusinessRegisterByEmailComponent,
    BusinessRegisterCompanyComponent,
    BusinessRegisterOnlineByYourselfComponent,
    BusinessRegistrationTestimonialComponent,

    BusinessRegistrationAdsComponent,
    BusinessRegistrationAdsIntroComponent,
    BusinessRegistrationAdsDetailListComponent,
    BusinessRegistrationAdsStepsComponent,
    BusinessRegistrationAdsVdoInviteComponent,
    BusinessRegistrationAds9CompanyComponent,
    BusinessRegistrationAdsKnowledgeComponent,
  ],
  imports: [
    CommonModule,
    BusinessRegistrationRoutingModule,
    CoreModule.forRoot(),
    CustomTranslateModule.forChild({ path: 'business-registration' }),
  ],
  providers: [
    // swiper
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
})
export class BusinessRegistrationModule {}
